import { Outlet } from "react-router-dom";

const ClientLedgerPayments = () => <Outlet />;

export default ClientLedgerPayments;
